import { LicensePlan } from '../types';
import { office365Plans } from './categories/office365';
import { m365EnterprisePlans } from './categories/m365enterprise';
import { m365BusinessPlans } from './categories/m365business';
import { m365FrontlinePlans } from './categories/m365frontline';
import { m365EducationPlans } from './categories/m365education';
import { m365GovernmentPlans } from './categories/m365government';

// Combine all plans into a single array
export const licensePlans: LicensePlan[] = [
  ...office365Plans,
  ...m365EnterprisePlans,
  ...m365BusinessPlans,
  ...m365FrontlinePlans,
  ...m365EducationPlans,
  ...m365GovernmentPlans
];
